module.exports = __webpack_public_path__ + "static/media/logosobral.fdbb3354.png";